<template>
    <module-card
        v-bind="params"
        :permissions="permissions"
        :loading="loading"
        :retryFunction="retryFunction"
        :error="iframeError"
        :errorText="enums.responses.error"
        :segmentations="segmentations"
        @visibleChanged="$emit('visibleChanged', $event)"
    >
        <template slot="content">
            <iframe
                scrolling="no"
                class="my-enterprise-iframe"
                :src="iframeUrl"
                :style="canIframeInteractStyle"
            />
        </template>
        <template slot="actions">
            <v-btn
                class="slin-btn"
                @click="$router.push({ name: 'myDecorated' })"
                :style="{ color: params.themeColor }"
            >
                <i class="bexsicon-decor-sm" />
                Ver empreendimento
            </v-btn>
            <v-btn
                v-if="tourUrl"
                class="slin-btn"
                @click="goToTour"
                :style="{ color: params.themeColor }"
            >
                <i class="bexsicon-tour" />
                Tour virtual
            </v-btn>
        </template>
    </module-card>
</template>

<script>
import ModuleCard from '@/components/layout/Card';
import { PROFILES, IFRAME, UNIT, SEGMENTATIONS } from '../../utils/constants';
import axios from 'axios';
import enums from '@/utils/enums';
export default {
  components: {
    ModuleCard
  },
  computed: {
    canIframeInteractStyle() {
      return {
        pointerEvents: this.$store.getters[IFRAME.GET_INTERACTION]
          ? 'all'
          : 'none'
      };
    },
    segmentations() {
      const product = this.$store.getters[UNIT.GET_SELECTED_PRODUCT];
      if (product) {
        const constructionStage = enums.constuctionStages[product.stage];
        switch (constructionStage) {
          case 'launch':
            return null;
            break;
          case 'inConstruction':
            return null;
            break;
          case 'delivered':
            if (this.$store.getters[UNIT.GET_SELECTED].keyDeliveryDate) {
              return [
                SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
                SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
                SEGMENTATIONS.SFH__REHEARSE_STATUS,
                SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
                SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
                SEGMENTATIONS.INDIRECT__USER_ROLE,
                SEGMENTATIONS.KEYS_DELIVERED__CONSTRUCTION_STAGE
              ];
            } else {
              return [
                SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
                SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
                SEGMENTATIONS.INDIRECT__USER_ROLE,
                SEGMENTATIONS.DELIVERED__CONSTRUCTION_STAGE
              ];
            }
            break;
        }
      }
      return null;
    }
  },
  data() {
    return {
      permissions: [
        PROFILES.ADMIN_PROFILE,
        PROFILES.ADMIN_BEXS_PROFILE,
        PROFILES.ADMIN_HR_PROFILE,
        PROFILES.HR_PROFILE
      ],
      iframeError: false
    };
  },
  props: {
    iframeUrl: {
      type: String,
      required: true
    },
    tourUrl: {
      type: String,
      default: ''
    },
    lastUpdate: String,
    stage: String,
    loading: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      required: true
    },
    retryFunction: Function
  },
  created() {
    this.getIframeStatus();
  },
  methods: {
    goToTour() {
      window.open(this.tourUrl, '_blank');
    },
    async getIframeStatus() {
      this.iframeError = !(await axios.head(this.iframeUrl).catch(err => {
        console.error(err.message);
      }));
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .v-card__text {
  padding-top: 0;
}
.my-enterprise-iframe {
  border: none;
  margin: 7% auto 0;
  padding: 0;
  height: 100%;
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/DecoratedCard.vue